import { render, staticRenderFns } from "./NewImpugnedTracker.vue?vue&type=template&id=323e4be8"
import script from "./NewImpugnedTracker.vue?vue&type=script&lang=js"
export * from "./NewImpugnedTracker.vue?vue&type=script&lang=js"
import style0 from "./NewImpugnedTracker.vue?vue&type=style&index=0&id=323e4be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports